<template>
  <div id="event-list-container" :class="{'lazy-icon': eventsLoading}">
    <h1>Bewegungsangebote</h1>
    <p>{{description}}</p>

    <div class="row">
      <div class="span4">
        <events-filter :filter-options="filterOptions" :anyFiltersSet="anyFiltersSet" v-if="filterLoaded" @reset-filter="resetFilter" @set-filter="setFilter" ref="filterBar" />
      </div>

      <div class="span8">

        <div class="row-fluid leftandright mb-1">
          <div class="title-bar--title">
            <h2 class="my-0">{{filteredEvents.length}} {{ filteredEvents.length == 1 ? 'Bewegungsangebot' : 'Bewegungsangebote'}}</h2>
          </div>
          <div class="title-bar--button">
            <button type="link" class="ic-fa-mapmarker link" @click="showMap = !showMap">
              {{ showMap ? 'Karte ausblenden' : 'Karte anzeigen' }}
            </button>
          </div>
        </div>

        <div class="mb-1">
          <event-map v-if="showMap" :events="filteredEvents" :filter-key="filterKey"/>
        </div>

        <div id="currentEvents">
          <events-list :events="filteredEvents" :loading="eventsLoading" ref="eventsList" :selected-date="currentFilter.dateString" />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import filterLoader from '../mixins/filterLoader.js'

// Load CSS from the published version
import EventsList from "../components/_events_list.vue"
import EventsFilter from "../components/_events_filter.vue"
import axios from 'axios';
import EventMap from "../components/_events_map.vue"

export default {
  name: 'EventsIndex',
  mixins: [filterLoader],
	components: {
    EventsList,
    EventsFilter,
    EventMap
	},
  data(){
    return {
      showMap: true,
      showDate: this.thisMonth(1),
      currentDate: this.thisMonth((new Date()).getDate()),
      description: document.querySelector('meta[name=description]').getAttribute('content'),
      overlayVisible: false,
      monthNames: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
      ]
    }
  },
  mounted(){
    this.setTabIndices("#header a, #header button")
    this.loadEvents()
  },

  methods: {
    setTabIndices(selector, start = 1){
      var elements = document.querySelectorAll(selector);

      elements.forEach((e,i) => {
        e.setAttribute('tabindex', start+i)
      })
    },
    loadEvents(){
      this.eventsLoading = true
      axios.get('/events.json').then(r => {
        this.events = r.data
        this.eventsLoading = false
      })

    },
		thisMonth(d, h, m) {
			const t = new Date()
			return new Date(t.getFullYear(), t.getMonth(), d, h || 0, m || 0)
		},
  }

}
</script>
